
import { Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="font-semibold text-lg mb-4">About On The Town</h3>
            <p className="text-sm text-primary-foreground/80">
              Your go-to directory for finding the perfect private dining and event spaces in NYC.
              We make it easy to discover and book venues for corporate events, private parties,
              and special occasions.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4">Explore</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-sm hover:text-primary-foreground/80 transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/contact" 
                  className="inline-flex items-center text-sm hover:text-primary-foreground/80 transition-colors"
                >
                  <Mail className="h-4 w-4 mr-2" />
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-primary-foreground/10 mt-8 pt-8 text-center text-sm text-primary-foreground/60">
          <p>&copy; {new Date().getFullYear()} On The Town. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
